import { Suspense, lazy } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { Button } from '@/components/ui/Button';
import { Spinner } from '@/components/ui/Spinner';

const AffiliatePanel = lazy(() =>
  import('@/pages/panels/AffiliatePanel').then((m) => ({ default: m.AffiliatePanel })),
);

/**
 * Standalone home for role='affiliate' accounts. These are partners who are
 * NOT platform subscribers — they get the affiliate portal and nothing else
 * (no sidebar, no dashboard / news / other panels). Rendered by App's role
 * split in place of the gated DashboardRoute.
 */
export function AffiliatePortal() {
  const { user, signOut } = useAuth();
  return (
    <div className="min-h-screen bg-bg text-fg">
      <header className="sticky top-0 z-20 flex h-14 items-center justify-between border-b border-border bg-bg/80 px-4 backdrop-blur sm:px-6">
        <span className="text-sm font-bold uppercase tracking-wide text-fg">
          TELOS <span className="text-accent">Partners</span>
        </span>
        <div className="flex items-center gap-3">
          <span className="hidden text-2xs text-fg-muted sm:inline">{user?.email}</span>
          <Button size="sm" variant="secondary" onClick={() => signOut()}>
            Sign out
          </Button>
        </div>
      </header>
      <main className="mx-auto w-full max-w-5xl px-4 py-6 sm:px-6">
        <Suspense
          fallback={
            <div className="flex items-center justify-center py-20">
              <Spinner className="size-6" />
            </div>
          }
        >
          <AffiliatePanel />
        </Suspense>
      </main>
    </div>
  );
}
